import React, { useState, useCallback } from "react";
import "../SideMenu.css";
import Vector from "./math/Vector";

const SideMenu = ({ inputValues, setInputValues, vectorCanvasRef }) => {
  const [isOpen, setIsOpen] = useState(true); // Controls visibility

  const handleInputChange = useCallback(
    (e, index) => {
      let inputValue = e.target.value;

      // Treat empty input as 0
      let numberValue = inputValue === "" ? 0 : Number(inputValue);

      const newValues = [...inputValues];
      newValues[index] = numberValue;
      setInputValues(newValues);

      // Update the vector canvas if it exists
      if (vectorCanvasRef.current) {
        vectorCanvasRef.current.setBasis(...newValues);
        vectorCanvasRef.current.draw();
      }
    },
    [inputValues, setInputValues, vectorCanvasRef]
  );

  const handleAddVector = () => {
    if (vectorCanvasRef.current) {
      vectorCanvasRef.current.addVector(new Vector([1, 1], "GREY"));
    }
  };

  return (
    <div className={`side-menu ${isOpen ? "open" : "collapsed"}`}>
      <button className="toggle-button" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "◀" : "▶"}
      </button>
      {isOpen && (
        <div className="menu-content">
          <h3>Matrix</h3>
          <div className="grid-container">
            {inputValues.map((value, index) => (
              <input
                key={index}
                type="number"
                value={inputValues[index] === "" ? "" : value}
                onChange={(e) => handleInputChange(e, index)}
              />
            ))}
          </div>

          {/* Eigenstuff Section
          <h3>Eigenstuff</h3>*/}

          {/* <div className="input-column">
            <label>λ1 * x:</label>
            <input type="number" />
            <input type="number" />
          </div> */}

          {/*<div className="input-column">
            <label>λ2 * x:</label>
            <input type="number" />
            <input type="number" />
          </div>

          <div className="input-column">
            <label>λ1:</label>
            <input type="number" />
          </div>

          <div className="input-column">
            <label>λ2:</label>
            <input type="number" />
          </div> */}
          <button className="add-vector-button" onClick={handleAddVector}>
            Add Vector
          </button>
        </div>
      )}
    </div>
  );
};

export default SideMenu;
